const ID = 'tile';

export default ID;
